import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { verifyPasscode } from '../../actions/url';
import PropTypes from 'prop-types';

const propTypes = {
  closeConfirm: PropTypes.func,
  text: PropTypes.string,
};

// instruction
// step 1
//  import setConfirmPasscodeModalVisibility from actions/baseModal_actions
// step 2
//  confirmPasscodeModal: {
//    visibility: false,
//    verified: false,
//  },
//  map confirmPasscodeModal state to the prop of the component you wish to use passcode modal
//  confirmPasscodeVerified: state.baseModals.confirmPasscodeModal.verified,
// step 3
//  after passcode has been verified, modal closes itself and state.baseModals.confirmPasscodeModal.verified will be true,
//  then you do w/e you have to do, then set the value of verified to false using setPasscodeVerificationStatus(false);
//  done

class VerifyPasscodeModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      passcode: '',
      errMsg: '',
    };
  }

  componentDidMount() {

  }

  componentWillReceiveProps() {

  }

  checkPasscode = () => {
    this.setState({
      errMsg: '',
    })
    const promise = new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: verifyPasscode,
        data: {
          passcode: this.state.passcode,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });

    promise.then((result) => {
      this.props.closeConfirm(true);
    }, (err) => {
      this.setState({
        errMsg: err.data,
      });
    });
  }

  handlePasscodeChange(e) {
    this.setState({
      passcode: e.target.value,
    });
  }

  renderButtons() {
    return (
      <div>
        <Button bsStyle="primary" className="mt mr" onClick={this.checkPasscode}><Translate value="Confirm" /></Button>
        <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeConfirm(); }}><Translate value="cancel" /></Button>
      </div>
    );
  }

  renderInput() {
    return (
      <span style={{ margin: '50px 0' }}>
        <input type="password" value={this.state.passcode} onChange={(e) => this.handlePasscodeChange(e)} style={{ border: '1px solid black', borderRadius: '4px', margin: '50px 0', padding: '10px' }} />
      </span>
    );
  }

  render() {
    const { errMsg } = this.state;
    return (
      <ContentWrapper>
        {
          this.props.text && (
            <Row>
              <Col sm={12} className="text-center" style={{ marginTop: '20px', fontSize: '20px', fontWeight: '400'}}>
                {
                  this.props.text
                }
              </Col>
            </Row>
          )
        }
        <Row>
          <Col sm={12} className="text-center" style={{ marginTop: '20px' }}>
            {this.renderInput()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="text-center">
            {this.renderButtons()}
          </Col>
        </Row>
        <br />
        {errMsg && <Row className="text-center alert alert-danger"><Translate value="your_passcode_is_not_correct" /></Row>}
        {/* {checkPermissionSuccess && !checkPermissionSuccess.manager && <Row className="text-center alert alert-danger"><Translate value="no_permission" /></Row>} */}
      </ContentWrapper>
    );
  }
}

VerifyPasscodeModal.propTypes = propTypes;

export default VerifyPasscodeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/VerifyPasscodeModal.jsx